import { AsyncPipe, KeyValuePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { GroupSelectComponent, GroupSelectOptionComponent } from '@rma/generic/ui/forms/group-select';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { filter, take } from 'rxjs';
import { PropertyTypes } from '../domain/property-types';
import { FindMyAgentStore } from '../orc-find-my-agent/find-my-agent.store';

@Component({
  selector: 'rma-property-type',
  imports: [
    AsyncPipe,
    GroupSelectComponent,
    GroupSelectOptionComponent,
    KeyValuePipe,
    MatButtonModule,
    ReactiveFormsModule,
    RmaIconComponent,
    RouterModule,
    TranslocoModule,
  ],
  templateUrl: './property-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyTypeComponent {
  public store = inject(FindMyAgentStore);

  control = new FormControl<PropertyTypes | null>(null);

  constructor() {
    this.control.valueChanges
      .pipe(filter(Boolean), take(1))
      .subscribe((propertyType) => this.store.patchState({ propertyType, nextStep: propertyType === 'land' ? 'whentosell' : 'bedrooms' }));
  }
}
